export const blurInputOnEnterKeyPress = (e: React.KeyboardEvent) => {
  const focusedInput: HTMLInputElement | null =
    document.querySelector('input:focus')
  if (e.key === 'Enter' && focusedInput) {
    focusedInput.blur()
    e.preventDefault()
  }
}
